import * as Adivery from 'adivery-js';
import {showLoading,Util , showErrorDialog} from "baziigram"
import {STORAGE_KEY,dictionary} from "../constants"
import appService from '../Service'


export const showAds=(callback,gameId)=>{
if(Util.getLanguage()=="en")
{
callback()
return
}
let watchedAds = getHistory();
if(watchedAds.interstitial+watchedAds.video>9)
 {callback()
 return
 }

if(watchedAds.counter%3==1 )
{
if(watchedAds.interstitial<=watchedAds.video)
showInterstitialAd(callback,gameId,watchedAds)

else
showVideoAd(callback,gameId,watchedAds)
}

else
callback()

updateHistory({counter:watchedAds.counter+1})

}

export const showRewardedAd=(callback,gameId)=>{
let language = Util.getLanguage();
 Adivery.configure("e0ad1434-2225-4b17-8fb2-67ae6018ed7d");
  showLoading(true)
  Adivery.requestRewardedAd("ae3de855-89f9-460f-b273-811399b0428c").then(
    (ad) => {
      console.log("Rewarded ad loaded");
      ad.show().then(
        (isRewarded) => {
          appService.AdsLog(isRewarded? "completed" :"not-complete","video",1,gameId).then(res=>{}).catch(err=>{})
       if(isRewarded)
         callback()
         else
         showErrorDialog(dictionary.watchToEnd[language])
        },
        (err) => {
        showErrorDialog(dictionary.AdLoadingError[language])
         }
      ).catch(err=>showErrorDialog(dictionary.AdLoadingError[language]))
    },
    (err) => {
     showErrorDialog(dictionary.AdLoadingError[language])
    }
  ).catch(err=>{showErrorDialog(dictionary.AdLoadingError[language])}).finally(res=>{showLoading(false)});
  }

export const showVideoAd=(callback,gameId,watchedAds)=>{
 Adivery.configure("e0ad1434-2225-4b17-8fb2-67ae6018ed7d");
  showLoading(true)
  Adivery.requestRewardedAd("ae3de855-89f9-460f-b273-811399b0428c").then(
    (ad) => {
      console.log("Rewarded ad loaded");
      ad.show().then(
        (isRewarded) => {
        updateHistory({"video":watchedAds.video+1})
          appService.AdsLog(isRewarded? "completed" :"not-complete","video",1,gameId).then(res=>{}).catch(err=>{})
          callback()
        },
        (err) => {
        callback()
          console.error("Failed to display rewarded ad", err);
        }
      ).catch(err=>{console.error(err);callback()})
    },
    (err) => {
    callback()
     console.error("Failed to load rewarded ad", err);
    }
  ).catch(err=>{console.error(err);callback()}).finally(res=>{showLoading(false)});
  }

  export const showInterstitialAd=(callback,gameId,watchedAds)=>{
   Adivery.configure("e0ad1434-2225-4b17-8fb2-67ae6018ed7d");
  showLoading(true)
  Adivery.requestInterstitialAd("43faea92-885e-400f-a79c-cc7972d3811f").then(
    (ad) => {
      console.log("Interstitial ad loaded");
      ad.show().then(
        () => {
        appService.AdsLog("watched","interstitial",1,gameId).then(res=>{}).catch(err=>{})
        updateHistory({"interstitial":watchedAds.interstitial+1})
          callback()
        },
        (err) => {
          callback()
          console.error("Failed to display insterstitial ad", err);
        }
      ).catch(err=>{console.error(err); callback()});
    },
    (err) => {
    callback()
      console.error("Failed to load interstitial ad", err);
    }
  ).catch(err=>{console.error(err);callback()}).finally(res=>{showLoading(false)});
  }


export const getHistory=()=>
{
let d = new Date()
let history = {"video":0,"interstitial":0 , counter:0 , lastTime:d.getTime()};
try
{
history = JSON.parse(Util.Storage.get(STORAGE_KEY.ADS_HISTORY)) || history;
}
catch(error){ console.error(error)}


if(d.getTime() - history.lastTime >= 24*60*60*1000 )
 history = {"video":0,"interstitial":0 , counter:0 , lastTime:d.getTime()}

return history
}

export const updateHistory=(newValues)=>
{
let history = getHistory()

Object.keys(newValues).map(key=>{
history[key] = newValues[key];
})

Util.Storage.save(STORAGE_KEY.ADS_HISTORY, JSON.stringify(history));


}